export default __webpack_public_path__ + "static/media/MDG.80160f44.svg";